import React, { Component } from "react";

import Video from "../../Components/Video";

class Mayu extends Component {
  render() {
    return (
      <div className="mayu">
        <Video video={"https://www.youtube.com/embed/o0jOP56nc0o"} />
      </div>
    );
  }
}

export default Mayu;
